import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'ServiceScreenSettingForm',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.pageTitle + ' | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  props: {
    serviceId: String,
    serviceContentsId: String,
    contentsScreenId: String
  },
  data () {
    return {
      loading: true
    }
  },
  // beforeMount () {
  //   if (this.getPermission('User')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    this.resetForm()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceScreenSetting.categoryName
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      isRegister: 'serviceScreenSettingForm/isRegister',
      isModify: 'serviceScreenSettingForm/isModify'
    }),
    
    pageTitle () {
      return this.isRegister ?
        this.categoryName + '新規作成' :
        this.categoryName + '編集'
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      loadModel: 'serviceScreenSettingForm/loadModel',
      resetForm: 'serviceScreenSettingForm/reset'
    }),

    init () {
      this.loading = true

      //
      let screenSettingParams = {
        serviceUuid: this.serviceId,
        serviceContentsUuid: this.serviceContentsId,
        contentsScreenUuid: this.contentsScreenId
      }

      // データ読出し
      this.loadModel({
        serviceId: this.serviceId,
        serviceContentsId: this.serviceContentsId,
        targetId: this.contentsScreenId,
        screenSettingParams: screenSettingParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    }
  }
}
